.root {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.header {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 10px 12px;
  background: var(--rec-color-warning);
  border: 1px solid var(--rec-color-warning-border);
  border-radius: 10px;
  text-align: left;
  cursor: pointer;
  font: inherit;
}

.icon {
  flex: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 11px;
  background: var(--rec-color-warning-border);
  color: var(--rec-color-warning-fg);
}

.label {
  flex: 1;
  min-width: 0;
  font-size: 11px;
  font-weight: 700;
  color: var(--rec-color-warning-fg);
}

.chevron {
  flex: none;
  display: inline-flex;
  color: var(--rec-color-warning-fg);
}

.list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
